module.exports = __webpack_public_path__ + "static/media/x.d5338c1b.svg";